// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hTrr","comment":"styles_comment__3nz_d"};